/* NEX header: ice rain inside the capsule + collection photo on hover + Winter / Summer / Hats / All Products mega panels */
(function () {
  'use strict';
  var hdr = document.querySelector('[data-header]');
  if (!hdr) return;
  var pill = hdr.querySelector('.hdr__pill');
  if (pill && !pill.querySelector('.hdr__rain')) {
    var r = document.createElement('div');
    r.className = 'hdr__rain'; r.setAttribute('aria-hidden', 'true');
    var h = '';
    for (var i = 0; i < 34; i++) {
      var dot = i % 5 === 0;
      h += '<i class="' + (dot ? 'd' : '') + '" style="left:' + ((i * 29 + 7) % 100) + '%;--w:' + (dot ? 3 : 1.5 + (i % 3) * .5) + 'px;--l:' + (dot ? 3 : 9 + (i * 7) % 9) + 'px;--t:' + (2.2 + (i * 13) % 20 / 10) + 's;--dl:-' + ((i * 17) % 30 / 10) + 's;--dx:' + ((i % 2) ? 5 : -5) + 'px"></i>';
    }
    r.innerHTML = h;
    if (getComputedStyle(pill).position === 'static') pill.style.position = 'relative';
    pill.insertBefore(r, pill.firstChild);
    var fit = function () { r.style.setProperty('--h', (pill.offsetHeight + 24) + 'px'); };
    fit(); window.addEventListener('resize', fit); window.addEventListener('load', fit);
  }

  var canHover = window.matchMedia('(hover:hover)').matches;
  function path(a) { try { return new URL(a.getAttribute('href'), location.origin).pathname; } catch (e) { return ''; } }
  function label(a) { return (a.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  /* Winter / Summer / Hats / All Products: the collections float side by side under the capsule */
  var mega = null, megaT = null, megaKey = null;
  if (canHover) {
    var data = {};
    try { data = JSON.parse((document.querySelector('[data-mega-map]') || {}).textContent || '{}'); } catch (e) {}
    if (data && !Array.isArray(data) && Object.keys(data).length) {
      mega = document.createElement('div');
      mega.className = 'hdr__mega';
      document.body.appendChild(mega);
      var snow = function () {
        var s = '<div class="hdr__megasnow" aria-hidden="true">';
        for (var n = 0; n < 26; n++) s += '<i style="left:' + ((n * 37 + 5) % 100) + '%;--s:' + (6 + (n % 4) * 3) + 'px;--d:' + (3.5 + (n % 5) * .7) + 's;--dl:-' + ((n * 0.37) % 4).toFixed(2) + 's;--dx:' + ((n % 2) ? 14 : -14) + 'px"></i>';
        return s + '</div>';
      };
      var fill = function (k) {
        if (megaKey === k) return;
        megaKey = k;
        mega.className = 'hdr__mega hdr__mega--' + k.replace(/\s+/g, '-');
        var items = data[k] || [], html = (k === 'winter' ? snow() : '') + '<ul>';
        items.forEach(function (c, i) {
          html += '<li style="--i:' + i + '"><a href="' + c.u + '"><img src="' + c.i + '" alt="" loading="lazy" width="240" height="300"><b>' + String(c.t).replace(/</g, '&lt;') + '</b></a></li>';
        });
        mega.innerHTML = html + '</ul>';
      };
      var megaOn = function (k) {
        clearTimeout(megaT);
        if (!data[k] || !data[k].length) return;
        fill(k);
        var pr = pill.getBoundingClientRect();
        mega.style.top = (pr.bottom + 8) + 'px';
        mega.classList.add('is-on');
      };
      var megaOff = function () { clearTimeout(megaT); megaT = setTimeout(function () { mega.classList.remove('is-on'); }, 200); };
      [].forEach.call(hdr.querySelectorAll('.hdr__links > li'), function (li) {
        var a = li.firstElementChild;
        if (!a) return;
        var k = label(a);
        if (!data[k]) return; var pn = li.getAttribute('data-dd'), pp = pn !== null ? hdr.querySelector('[data-dd-panel="' + pn + '"]') : null; if (pp) pp.classList.add('hdr__dd--mega');
        li.addEventListener('mouseenter', function () { megaOn(k); });
        li.addEventListener('mouseleave', megaOff);
        a.addEventListener('focus', function () { megaOn(k); });
      });
      mega.addEventListener('mouseenter', function () { clearTimeout(megaT); });
      mega.addEventListener('mouseleave', megaOff);
      window.addEventListener('scroll', function () { mega.classList.remove('is-on'); }, { passive: true });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') mega.classList.remove('is-on'); });
    }
  }

  /* hover photo */
  var map = {};
  try { map = JSON.parse((document.querySelector('[data-hover-map]') || {}).textContent || '{}'); } catch (e) {}
  if (!Object.keys(map).length || !canHover) return;
  var peek = document.createElement('div');
  peek.className = 'hdr__peek'; peek.setAttribute('aria-hidden', 'true');
  peek.innerHTML = '<img alt=""><span></span>';
  document.body.appendChild(peek);
  var im = peek.firstChild, cap = peek.lastChild, hideT = null, cur = null;
  function show(a) {
    var m = map[path(a)];
    if (!m) { hide(true); return; }
    clearTimeout(hideT);
    var li = a.closest('.hdr__links > li'), box = a.closest('.hdr__dd');
    var panel = box || (li && li.getAttribute('data-dd') !== null ? hdr.querySelector('[data-dd-panel="' + li.getAttribute('data-dd') + '"]') : null);
    setTimeout(function () {
      if (cur !== a) return;
      var W = 190, H = 260, x, y, ar = a.getBoundingClientRect();
      if (panel && !panel.hidden) {
        var pb = (panel.querySelector('.hdr__ddbox') || panel).getBoundingClientRect();
        x = pb.right + 14; y = pb.top;
        if (x + W > innerWidth - 8) x = pb.left - W - 14;
      } else {
        var pr = pill.getBoundingClientRect();
        x = ar.left + ar.width / 2 - W / 2; y = pr.bottom + 10;
      }
      x = Math.max(8, Math.min(x, innerWidth - W - 8));
      y = Math.max(8, Math.min(y, innerHeight - H - 8));
      peek.style.left = x + 'px'; peek.style.top = y + 'px';
      if (im.getAttribute('src') !== m.i) im.setAttribute('src', m.i);
      cap.textContent = m.t || (a.getAttribute('aria-label') || a.textContent || '').trim();
      peek.classList.add('is-on');
    }, 70);
  }
  function hide(now) { clearTimeout(hideT); hideT = setTimeout(function () { peek.classList.remove('is-on'); }, now ? 0 : 120); }
  hdr.addEventListener('mouseover', function (e) {
    var a = e.target.closest('.hdr__links a, .hdr__ddbox a');
    if (!a || a === cur) return;
    cur = a; show(a);
  });
  hdr.addEventListener('mouseout', function (e) {
    var a = e.target.closest('.hdr__links a, .hdr__ddbox a');
    if (!a) return;
    var to = e.relatedTarget && e.relatedTarget.closest ? e.relatedTarget.closest('.hdr__links a, .hdr__ddbox a') : null;
    if (to) return;
    cur = null; hide();
  });
  window.addEventListener('scroll', function () { cur = null; hide(true); }, { passive: true });
})();
